import { useContext, useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { LangContext } from "../../context/LangContext";

import useViewport from "../../hooks/useViewport";

import BtnReturn from "../../components/BtnReturn";
import Awards from "../../components/Awards";
import Slider from "../../components/Slider";
import Textarea from "../../components/Textarea";
import Gallery from "../../components/Gallery";

import "./style.css"

import icon_amazon from '../../assets/img/icon_amazon.png';

function Work() {
    const { slug } = useParams();
    const { isDesktop } = useViewport();
    
    const [work, setWork] = useState(null);
    const [logoStyle, setLogoStyle] = useState(null);
    
    const { language, translations } = useContext(LangContext);

    useEffect(() => {
        const fetchWork = async () => {
            const req = await fetch(`${process.env.REACT_APP_API_URL}/works/get/${slug}`);
            const res = await req.json();

            if (req.status !== 200) {
                alert(res.message);
                return
            };
            setWork(res);
        }
        fetchWork();
    }, [slug]);

    useEffect(() => {
        if (!work?.logo?.url) {
            setLogoStyle(null)
            return;
        }

        const img = new Image();
        img.src = work.logo._url;

        img.onload = () => {
            const heightMax = !isDesktop ? 210 : 340;

            // height
            if (img.naturalWidth < img.naturalHeight) {
                setLogoStyle({
                    height: `${heightMax}px`,
                    aspectRatio: `${img.naturalWidth} / ${img.naturalHeight}`,
                    backgroundImage: `url(${work.logo[`${isDesktop ? '' : '_'}url`]})`
                });
            }
            // width
            else {
                setLogoStyle({
                    width: '100%',
                    maxHeight: img.naturalHeight > heightMax ? `${heightMax}px` : 'unset',
                    aspectRatio: `${img.naturalWidth} / ${img.naturalHeight}`,
                    backgroundImage: `url(${work.logo[`${isDesktop ? '' : '_'}url`]})`
                });
            }
        };
    }, [isDesktop, work]);

    return work && (
        <div className='page page_work'>
            <BtnReturn to={localStorage.getItem('opt_return_work')} />

            {!isDesktop &&
                <div className="logo_work">
                    <i className="img" style={logoStyle} />
                    {work[`awards_${language}`].length !== 0 && <Awards serie={work} />}
                </div>
            }

            <section className="sect_presentation">
                <Slider images={work.images} link={work.amazon} />

                <div className="work_descrip">
                    {isDesktop &&
                        <div className="logo_work">
                            <i className="img" style={logoStyle} />
                            {work[`awards_${language}`].length !== 0 && <Awards serie={work} />}
                        </div>
                    }

                    <Textarea
                        label={translations.detail_and_descrip}
                        text={work[`descrip_${language}`]}
                    />

                    <p className="field first_field"><span>{translations.editor} :</span>{work.editor}</p>
                    <p className="field"><span>{translations.pegi} :</span>{work[`pg_${language}`]}</p>
                    <p className="field"><span>{translations.genre} :</span>{work.genre}</p>
                    <p className="field"><span>{translations.theme} :</span>{work[`theme_${language}`]}</p>
                    <p className="field"><span>{translations.ongoing_series} :</span>{work[`in_progress_${language}`]}</p>

                    {work.patreon && <Link className="link" to={work.patreon}>{translations.read_online}</Link>}
                    {work.chapiter && <Link className="link" to={work.chapiter}>{translations.read_first_chapter}</Link>}

                    {!isDesktop && work.amazon && <Link className="link_amazon" to={work.amazon}><img src={icon_amazon} alt="" /></Link>}
                </div>
            </section>

            {work.video.length !== 0 &&
                <section className="sect_videos">
                    <h2 className="subtitle_page">-<span>Trailer</span>-</h2>

                    <ul>
                        {work.video.map((url, idx) =>
                            <li key={idx} className="video">
                                <iframe
                                    title="video"
                                    src={url.replace("youtube.com", "youtube-nocookie.com")}

                                    width="100%"
                                    height="100%"

                                    frameBorder="0"
                                    allowFullScreen
                                ></iframe>
                            </li>
                        )}
                    </ul>
                </section>
            }

            {work.gallery.length !== 0 &&
                <section className="sect_gallery">
                    <h2 className="subtitle_page">-<span>Gallery</span>-</h2>

                    <Gallery images={work.gallery} />
                </section>
            }
        </div>
    )
}

export default Work;